import React, { useContext } from "react";

import { HttpMetricsContextType } from "./types";

export const HttpMetricsContext =
  React.createContext<HttpMetricsContextType | null>(null);

export const useHttpMetricsContext = <D = any>() =>
  useContext(HttpMetricsContext) as HttpMetricsContextType<D>;
